// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.App {
    /* text-align: center; */
    overflow-y: hidden;
}

.App-logo {
    height: 33vmin;
    pointer-events: none;
    animation: moveRightGlobal 1s;
}

@media (prefers-reduced-motion: no-preference) {
    .App-animated-line {
        width: 20%;
    }
}

.App-header {
    background-color: #0b132b;
    background: -webkit-linear-gradient(#0b132b 45%, #2b6b6a 140%);
    min-height: 100vh;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    font-size: calc(10px + 2vmin);
    color: white;
    transition: background 1s ease-out;
}

.loginDisplayContainer {
    display: flex;
    flex-wrap: wrap;
    flex-direction: row;
    justify-content: center;
    row-gap: 2em;
    column-gap: 4em;
    /* border: 1px solid black; */
    width: 90%;
}

.imageContainerLogin {
    float: left;
    /* border: 1px solid black; */
    animation: fadeInGlobal 10s;
}

.termsOfServcieDisplayText {
    position: absolute;
    right: 1em;
    top: 1em;
    font-size: 12px;
    opacity: 0.1;
}

.termsOfServcieDisplayText:hover {
    cursor: pointer;
}

.textContainerLogin {
    /* border: 1px solid black; */
    display: flex;
    justify-content: center;
    flex-direction: column;
    max-width: 60%;
    animation: moveLeftGlobal 1s;
}

.supTextLoginContainer {
    padding-top: 1em;
    /* border: 1px solid black; */
}

.supTextLogin {
    font-size: 17px;
    color: white;
    text-align: left;
    word-break: break-word;
}

.loginbuttonContainer {
    padding-top: 2em;
    padding: 1em;
}

.loginElementButton {
    padding-right: 0.5em;
}

.App-link {
    color: #61dafb;
}

.App-domain {
    color: white;
    font-family: var(--googleFont);
    font-weight: 900;
    font-size: 2em;
}

.App-domain2 {
    color: var(--HighlightBlue);
    font-family: var(--googleFont);
}

/* footer section */
.App-footer {
    display: none;
}

.App-phantom {
    display: block;
    padding: 5px;
    height: 2px;
    width: 100%;
}

.App-style {
    background-color: #f5f5f5;
    border-top: 1px solid black;
    /* text-align: center; */
    padding: 20px;
    position: fixed;
    left: 0;
    bottom: 0;
    height: 50px;
    width: 100%;
}

.buttonStyleGreen {
    background-color: #4caf50;
    /* Green */
    border: none;
    color: white;
    padding: 15px 32px;
    text-align: center;
    text-decoration: none;
    display: inline-block;
    font-size: 16px;
    margin: 5px;
}

.buttonStyleRed {
    background-color: #f44336;
    /* Green */
    border: none;
    color: white;
    padding: 15px 32px;
    text-align: center;
    text-decoration: none;
    display: inline-block;
    font-size: 16px;
    margin: 5px;
}

@media only screen and (max-width: 1035px) {
    .loginbuttonContainer {
        text-align: center;
    }
}

@media only screen and (max-width: 890px) {
    .textContainerLogin {
        max-width: none;
    }

    .loginbuttonContainer {
        text-align: center;
    }
}
`, "",{"version":3,"sources":["webpack://./src/components/Homepage/HomePage.css"],"names":[],"mappings":"AAAA;IACI,wBAAwB;IACxB,kBAAkB;AACtB;;AAEA;IACI,cAAc;IACd,oBAAoB;IACpB,6BAA6B;AACjC;;AAEA;IACI;QACI,UAAU;IACd;AACJ;;AAEA;IACI,yBAAyB;IACzB,8DAA8D;IAC9D,iBAAiB;IACjB,aAAa;IACb,sBAAsB;IACtB,mBAAmB;IACnB,uBAAuB;IACvB,6BAA6B;IAC7B,YAAY;IACZ,kCAAkC;AACtC;;AAEA;IACI,aAAa;IACb,eAAe;IACf,mBAAmB;IACnB,uBAAuB;IACvB,YAAY;IACZ,eAAe;IACf,6BAA6B;IAC7B,UAAU;AACd;;AAEA;IACI,WAAW;IACX,6BAA6B;IAC7B,2BAA2B;AAC/B;;AAEA;IACI,kBAAkB;IAClB,UAAU;IACV,QAAQ;IACR,eAAe;IACf,YAAY;AAChB;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,6BAA6B;IAC7B,aAAa;IACb,uBAAuB;IACvB,sBAAsB;IACtB,cAAc;IACd,4BAA4B;AAChC;;AAEA;IACI,gBAAgB;IAChB,6BAA6B;AACjC;;AAEA;IACI,eAAe;IACf,YAAY;IACZ,gBAAgB;IAChB,sBAAsB;AAC1B;;AAEA;IACI,gBAAgB;IAChB,YAAY;AAChB;;AAEA;IACI,oBAAoB;AACxB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,YAAY;IACZ,8BAA8B;IAC9B,gBAAgB;IAChB,cAAc;AAClB;;AAEA;IACI,2BAA2B;IAC3B,8BAA8B;AAClC;;AAEA,mBAAmB;AACnB;IACI,aAAa;AACjB;;AAEA;IACI,cAAc;IACd,YAAY;IACZ,WAAW;IACX,WAAW;AACf;;AAEA;IACI,yBAAyB;IACzB,2BAA2B;IAC3B,wBAAwB;IACxB,aAAa;IACb,eAAe;IACf,OAAO;IACP,SAAS;IACT,YAAY;IACZ,WAAW;AACf;;AAEA;IACI,yBAAyB;IACzB,UAAU;IACV,YAAY;IACZ,YAAY;IACZ,kBAAkB;IAClB,kBAAkB;IAClB,qBAAqB;IACrB,qBAAqB;IACrB,eAAe;IACf,WAAW;AACf;;AAEA;IACI,yBAAyB;IACzB,UAAU;IACV,YAAY;IACZ,YAAY;IACZ,kBAAkB;IAClB,kBAAkB;IAClB,qBAAqB;IACrB,qBAAqB;IACrB,eAAe;IACf,WAAW;AACf;;AAEA;IACI;QACI,kBAAkB;IACtB;AACJ;;AAEA;IACI;QACI,eAAe;IACnB;;IAEA;QACI,kBAAkB;IACtB;AACJ","sourcesContent":[".App {\n    /* text-align: center; */\n    overflow-y: hidden;\n}\n\n.App-logo {\n    height: 33vmin;\n    pointer-events: none;\n    animation: moveRightGlobal 1s;\n}\n\n@media (prefers-reduced-motion: no-preference) {\n    .App-animated-line {\n        width: 20%;\n    }\n}\n\n.App-header {\n    background-color: #0b132b;\n    background: -webkit-linear-gradient(#0b132b 45%, #2b6b6a 140%);\n    min-height: 100vh;\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    justify-content: center;\n    font-size: calc(10px + 2vmin);\n    color: white;\n    transition: background 1s ease-out;\n}\n\n.loginDisplayContainer {\n    display: flex;\n    flex-wrap: wrap;\n    flex-direction: row;\n    justify-content: center;\n    row-gap: 2em;\n    column-gap: 4em;\n    /* border: 1px solid black; */\n    width: 90%;\n}\n\n.imageContainerLogin {\n    float: left;\n    /* border: 1px solid black; */\n    animation: fadeInGlobal 10s;\n}\n\n.termsOfServcieDisplayText {\n    position: absolute;\n    right: 1em;\n    top: 1em;\n    font-size: 12px;\n    opacity: 0.1;\n}\n\n.termsOfServcieDisplayText:hover {\n    cursor: pointer;\n}\n\n.textContainerLogin {\n    /* border: 1px solid black; */\n    display: flex;\n    justify-content: center;\n    flex-direction: column;\n    max-width: 60%;\n    animation: moveLeftGlobal 1s;\n}\n\n.supTextLoginContainer {\n    padding-top: 1em;\n    /* border: 1px solid black; */\n}\n\n.supTextLogin {\n    font-size: 17px;\n    color: white;\n    text-align: left;\n    word-break: break-word;\n}\n\n.loginbuttonContainer {\n    padding-top: 2em;\n    padding: 1em;\n}\n\n.loginElementButton {\n    padding-right: 0.5em;\n}\n\n.App-link {\n    color: #61dafb;\n}\n\n.App-domain {\n    color: white;\n    font-family: var(--googleFont);\n    font-weight: 900;\n    font-size: 2em;\n}\n\n.App-domain2 {\n    color: var(--HighlightBlue);\n    font-family: var(--googleFont);\n}\n\n/* footer section */\n.App-footer {\n    display: none;\n}\n\n.App-phantom {\n    display: block;\n    padding: 5px;\n    height: 2px;\n    width: 100%;\n}\n\n.App-style {\n    background-color: #f5f5f5;\n    border-top: 1px solid black;\n    /* text-align: center; */\n    padding: 20px;\n    position: fixed;\n    left: 0;\n    bottom: 0;\n    height: 50px;\n    width: 100%;\n}\n\n.buttonStyleGreen {\n    background-color: #4caf50;\n    /* Green */\n    border: none;\n    color: white;\n    padding: 15px 32px;\n    text-align: center;\n    text-decoration: none;\n    display: inline-block;\n    font-size: 16px;\n    margin: 5px;\n}\n\n.buttonStyleRed {\n    background-color: #f44336;\n    /* Green */\n    border: none;\n    color: white;\n    padding: 15px 32px;\n    text-align: center;\n    text-decoration: none;\n    display: inline-block;\n    font-size: 16px;\n    margin: 5px;\n}\n\n@media only screen and (max-width: 1035px) {\n    .loginbuttonContainer {\n        text-align: center;\n    }\n}\n\n@media only screen and (max-width: 890px) {\n    .textContainerLogin {\n        max-width: none;\n    }\n\n    .loginbuttonContainer {\n        text-align: center;\n    }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
